import Masonry from 'masonry-layout';
export default (function () {
  // Custom Select
  $('select').customSelect();
  // masonry for history items
  function masonryItems() {
    var grid = document.querySelector('.history__inner');
    if (grid != null) {
      var msnry = new Masonry(grid, {
        itemSelector: '.history__item'
      });
      msnry.once('layoutComplete', function () {
        grid.classList.add('load');
      });
      setTimeout(function () {
        msnry.layout();
      }, 500);

      // Get element's position relative to the viewport for history
      if ($(window).width() > 768) {
        var rectHistoryContainer = $('.history__inner').get(0).getBoundingClientRect();
        $('.history__item').each(function () {
          var rectHistoryItem = $(this).get(0).getBoundingClientRect();
          if (rectHistoryItem.x !== rectHistoryContainer.x) {
            $(this).addClass('right');
          }
        });
      } else {
        $('.history__item').removeClass('right');
      }
    }
  }
  $(window).on("load resize", function () {
    masonryItems();
  });

  // scroll to top
  $("a.scroll-to-top").click(function (e) {
    e.preventDefault();
    $("html, body").animate({
      scrollTop: 0
    }, "slow");
  });

  //Team Filter
  $('.team__filter [name="category"]').change(function () {
    var selectedCat = $(this).val();
    var membersWrapp = $(this).parents('.team');
    if (!selectedCat) {
      membersWrapp.find('.team-member').show();
    } else {
      membersWrapp.find('.team-member').each(function () {
        if ($(this).hasClass(selectedCat)) {
          $(this).show();
        } else {
          $(this).hide();
        }
      });
    }
  });

  //Project Filter
  $('.projects [name="category"]').each(function () {
    var select = $(this);
    var projectsWrapp = select.closest('.projects');
    var grid = projectsWrapp.find('.projects-grid');
    var items = grid.find('.projects__item').toArray();
    select.on('change', function () {
      var selectedCat = $(this).val();
      grid.empty();
      if (!selectedCat) {
        items.forEach(function (el) {
          grid.append(el);
        });
      } else {
        items.forEach(function (el) {
          if ($(el).hasClass(selectedCat)) {
            grid.append(el);
          }
        });
      }
    });
  });
  $.fn.isInViewport = function () {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
  };
  $(window).on("load scroll", function () {
    $('.animate-element').each(function () {
      if ($(this).isInViewport()) {
        $(this).addClass('in-view');
      }
    });
  });
});